
import txPlay from '@/views/userPlay/index.vue'
const vPlay = ()=>import('@/views/stuSchedule/rhPlay.vue')
const vPlayLive = ()=>import('@/views/stuSchedule/rhPlayLive.vue')
import playexcessivePage from  '@/views/userPlay/excessivePage.vue'
export const videoRouters = [
    {
        path: '/userPlay',
        name: 'userPlay',
        component: txPlay,
    },
    {
        path: '/stu-Play',
        name: 'stu-Play',
        component: vPlay,
        meta:{
            title:'直播'
        }
    },
    {
        path: '/play-excessivePage',
        name: 'play-excessivePage',
        component: playexcessivePage,
        meta:{
            title:'模拟登录'
        }
    },
    {
        path: '/stu-Play-live',
        name: 'stu-Play-live',
        component: vPlayLive,
        meta:{
            title:'直播'
        }
    },
    {
        path: '/play-video',
        name: 'play-video',
        component: ()=>import('@/views/play-video/index.vue'),
        meta:{
            title:'播放视频'
        }
    },
]